import React from 'react';
import { FillVariable, inputTypeFor } from '../utils';
import { Textarea } from '@/components/ui-kit/textarea';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui-kit/select';
import { Input } from '@/components/ui-kit/input';

interface Props {
  v: FillVariable;
  value: string;
  invalid: boolean;
  setValue: (name: string, value: string) => void;
  setCompanyValue: (name: string, value: string) => void;
}

export default function RenderFormControl({
  v,
  value = '',
  invalid,
  setCompanyValue,
  setValue,
}: Props) {
  const id = `fill-${v.name}`;
  const describedBy =
    [v.helpText ? `${id}-help` : null, invalid ? `${id}-error` : null].filter(Boolean).join(' ') ||
    undefined;
  // A shared company writes through to every linked token; everything else is 1:1.
  const change = v.subKind === 'company' ? setCompanyValue : setValue;

  if (v.type === 'textarea') {
    return (
      <Textarea
        id={id}
        aria-invalid={invalid || undefined}
        aria-describedby={describedBy}
        value={value}
        onChange={(e) => change(v.name, e.target.value)}
        placeholder={v.placeholder ?? undefined}
        className="min-h-24"
      />
    );
  }

  if (v.type === 'select') {
    return (
      <Select value={value} onValueChange={(val) => change(v.name, val)}>
        <SelectTrigger id={id} aria-invalid={invalid || undefined} aria-describedby={describedBy}>
          <SelectValue placeholder="Select an option…" />
        </SelectTrigger>
        <SelectContent>
          {v.options.map((opt) => (
            <SelectItem key={opt} value={opt}>
              {opt}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    );
  }

  return (
    <Input
      id={id}
      aria-invalid={invalid || undefined}
      aria-describedby={describedBy}
      type={inputTypeFor[v.type] ?? 'text'}
      step={v.type === 'number' || v.type === 'currency' ? 'any' : undefined}
      inputMode={v.type === 'currency' ? 'decimal' : undefined}
      value={value}
      onChange={(e) => change(v.name, e.target.value)}
      placeholder={v.placeholder ?? undefined}
    />
  );
}
